import React from 'react';
import { DatabaseBlockContainerProps } from './databaseViewBlockProps';
import { ReportingContainerBaseConfig } from '../../base';
import {
    DatabaseBlockController,
    DatabaseBlockLoader,
    DatabaseBlockStateProvider,
} from './databaseViewBlockInterface';
import { useSearchParams } from 'react-router-dom';

export function createDatabaseBlockContainer(
    config: ReportingContainerBaseConfig & {
        keys: {
            recordUrlParam: string;
        };
    },
    states: DatabaseBlockStateProvider,
    loader: DatabaseBlockLoader,
    controller: DatabaseBlockController
): React.FC<DatabaseBlockContainerProps> {
    const {
        kernel: {
            infra: {
                toaster: { useToast },
            },
        },
        context: { useContext },
    } = config;
    return ({ as: View, ...containerProps }) => {
        const context = {
            root: useContext(),
            block: config.infra.editor.context.useContext(),
        };
        const state = states.useState(context.root, containerProps);
        const [searchParams, setSearchParams] = useSearchParams();
        const data = loader.useLoad(context.root, containerProps);
        const props = controller.useProps(context.root, data, {
            query: data.content.query,
            record: {
                onOpen(item) {
                    searchParams.set(config.keys.recordUrlParam, item.id);
                    setSearchParams(searchParams, { replace: true });
                },
            },
            item: {
                adapter: context.block.adapter,
            },
            filter: {
                visible: {
                    value: state.filterVisible.value,
                    onChange: state.filterVisible.onChange,
                },
                value: state.filter.value,
                onAdd(property, value) {
                    state.filter.onChange({
                        ...state.filter.value,
                        [property.key]: value,
                    });
                },
                onRemove(property) {
                    state.filter.onChange(
                        Object.fromEntries(
                            Object.entries(state.filter.value).filter(
                                ([key]) => key !== property.key
                            )
                        )
                    );
                },
                onClear() {
                    state.filter.onChange({});
                },
            },
        });
        return <View {...props} />;
    };
}
